import { FunctionComponent, useContext, useState } from "react";
import styles from "./FilterDropdown.module.css";
import { useLazyQuery } from "@apollo/client";
import FilterTitle from "./FilterTitle";
import { GET_LEAGUES_LIST } from "../../../../features/Tickets/api/TicketsQuery";
import "react-datepicker/dist/react-datepicker.css";
import { globalContext } from "../../../../Provider/AppProvider";
import images from "../../../../assets/images/index";
import { DateFilter, LeagueListMenu, ResetApplyButtons, convertStringToDate, extractLeagues, formatDateWithHyphen, showCustomRange } from "../../../../helper";

interface FilterDropdownProps {
  activetab ?: number
  handleCloseFilterDropDown: () => void
}

interface LeagueObjectType{
  l_id: string,
  l_name: string,
}
interface LeaguesList{
    leagues: LeagueObjectType[]
}

const DelistAndReturnFilterDropdown: FunctionComponent<FilterDropdownProps> = ({handleCloseFilterDropDown}) => {
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const [returnFilterStartDate,setReturnFilterStartDate] = useState<string | null>(null);
  const [returnFilterEndDate, setReturnFilterEndDate] = useState<string | null>(null);
  const [returnFilterStartDateRange,setReturnFilterStartDateRange] = useState<string | null>(null);
  const [returnFilterEndDateRange, setReturnFilterEndDateRange] = useState<string | null>(null);
  const [returnFilterLeagueId,setReturnFilterLeagueId] = useState<string | null>(globalState.delistAndReturnTicketFilter.leagueId || null);
  const {dropdownIcon} = images;
  const [anchorEl, setAnchorEl] = useState<EventTarget | null>(null);
  const [returnLeague , setReturnLeague] = useState<string>(globalState.delistAndReturnTicketFilter.leagueName || "")
  const [days, setDays] = useState<string>(globalState.delistAndReturnTicketFilter.selectedDateValue || "")
  const [startDateReturn, setStartDateReturn] = useState<any>('');
  const [endDateReturn, setEndDateReturn] = useState<any>('');
  const [showDatePickerReturn, setShowDatePickerReturn] = useState<boolean>(false);
  const [customRangeReturn, setCustomrangeReturn] = useState<boolean>(false);

const [leagueslistDataInReturn,setLeaguesListInReturn] = useState<LeaguesList>();

  const [getLeaguesListForReturnFilter] = useLazyQuery(GET_LEAGUES_LIST, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if(data){
        const extractedData = data?.leagues
        ?.filter((item: LeagueObjectType) => !extractLeagues.includes(item?.l_name))
        .map((result:LeagueObjectType) => result);
        setLeaguesListInReturn(extractedData);
      }
    }
   });

  const handleClickOpenMenu = (e: React.MouseEvent<HTMLInputElement>) =>{
    setAnchorEl(e.currentTarget);
    getLeaguesListForReturnFilter();
  }

  const handleCloseMenu = ()=>{
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);

  const handleSelectleague = (league: LeagueObjectType) =>{
    setReturnLeague(league?.l_name);
    setReturnFilterLeagueId(league?.l_id);
    setAnchorEl(null)
  }

  const handleCancel = () =>{
    const tempData = {...globalState};
    tempData.delistAndReturnTicketFilter.isFilter = false;
    tempData.delistAndReturnTicketFilter.leagueId = null;
    tempData.delistAndReturnTicketFilter.leagueName = '';
    tempData.delistAndReturnTicketFilter.ticketStatus = null;
    tempData.delistAndReturnTicketFilter.startdate = null;
    tempData.delistAndReturnTicketFilter.enddate = null;
    tempData.delistAndReturnTicketFilter.startDateRange = null;
    tempData.delistAndReturnTicketFilter.endDateRange = null;
    tempData.delistAndReturnTicketFilter.selectedDateValue = '';
    tempData.delistAndReturnTicketFilter.isCustomRange = false;
    tempData.delistAndReturnTicketFilter.clicked = true;

    handleGlobalState(tempData);
    setReturnLeague("")
    setDays("")
    setStartDateReturn("");
    setEndDateReturn("");
    setReturnFilterStartDate(null);
    setReturnFilterEndDate(null);
    setReturnFilterStartDateRange(null);
    setReturnFilterEndDateRange(null);
    setReturnFilterLeagueId(null);
    setShowDatePickerReturn(false)
    setCustomrangeReturn(false)
  }

  const handleClickDays = (day: string) =>{
    setStartDateReturn('');
    setEndDateReturn('');
    setReturnFilterStartDateRange(null);
    setReturnFilterEndDateRange(null);
    const {startdate,enddate} = convertStringToDate(day);
    setReturnFilterStartDate(startdate);
    setReturnFilterEndDate(enddate);
    setDays(day);
  }

  const listDatePickerChange = (dates: [start: Date,end: Date]) => {
    const [start, end] = dates; 
    setReturnFilterStartDate(null);
    setReturnFilterEndDate(null);
    setReturnFilterStartDateRange(start  && formatDateWithHyphen(start));
    setReturnFilterEndDateRange(end && formatDateWithHyphen(end));
    setStartDateReturn(start);
    setEndDateReturn(end);
    setDays('')
    setCustomrangeReturn(false)
  };

  const handleClicklistCustomRange = () =>{
    setShowDatePickerReturn(true)
    setDays('')
    setCustomrangeReturn(false);
  }

  const handleClicklistDatePickerOutside = () =>{
    setShowDatePickerReturn(false)
    setCustomrangeReturn(true)
    setDays('')
    if(endDateReturn === null){
      setReturnFilterEndDateRange(startDateReturn && formatDateWithHyphen(startDateReturn));
      setEndDateReturn(startDateReturn)
    }
  }

const showDayTick = () => {
  if(returnFilterStartDateRange && returnFilterEndDateRange){
    return '';
  }else {
    if(days === '' && globalState.delistAndReturnTicketFilter.selectedDateValue === ''){
      return '';
    }else if(days){
      return days;
    }else if(globalState.delistAndReturnTicketFilter.selectedDateValue){
      return globalState.delistAndReturnTicketFilter.selectedDateValue;
    }
  }
}

const showCustomRangeValues = () => {
  if(returnFilterStartDate){
     return '';
  }else {
    if(customRangeReturn === false && globalState.delistAndReturnTicketFilter.isCustomRange === false){
      return;
     }else if(customRangeReturn){
       return (<span className={styles.dateformat}>{showCustomRange(startDateReturn,endDateReturn,"delistandreturn",globalState)}</span>);
     }else if(globalState.delistAndReturnTicketFilter.isCustomRange){
       return (<span className={styles.dateformat}>{showCustomRange(startDateReturn,endDateReturn,"delistandreturn",globalState)}</span>);
     }
  }
}
const handleSubmitFilter = () => {
  const tempData = {...globalState};
  if(returnFilterLeagueId || returnFilterStartDate || returnFilterStartDateRange){
    tempData.delistAndReturnTicketFilter.isFilter = true;
    tempData.delistAndReturnTicketFilter.clicked = true;
  }
  if(returnFilterStartDateRange && returnFilterEndDateRange){
    tempData.delistAndReturnTicketFilter.startdate = null;
    tempData.delistAndReturnTicketFilter.enddate = null;
    tempData.delistAndReturnTicketFilter.startDateRange = returnFilterStartDateRange ? returnFilterStartDateRange : globalState.delistAndReturnTicketFilter.startDateRange;
    tempData.delistAndReturnTicketFilter.endDateRange = returnFilterEndDateRange ? returnFilterEndDateRange : globalState.delistAndReturnTicketFilter.endDateRange;
  }else{
    if(days === 'Today' || days === 'Yesterday'){
      tempData.delistAndReturnTicketFilter.startdate = returnFilterStartDate ? returnFilterStartDate : globalState.delistAndReturnTicketFilter.startdate;
      tempData.delistAndReturnTicketFilter.enddate = null;
      tempData.delistAndReturnTicketFilter.startDateRange = null;
      tempData.delistAndReturnTicketFilter.endDateRange = null;
    }else {
      if(globalState.delistAndReturnTicketFilter.startDateRange && globalState.delistAndReturnTicketFilter.endDateRange){
         if(returnFilterStartDate && returnFilterEndDate){
          tempData.delistAndReturnTicketFilter.startdate = returnFilterStartDate ? returnFilterStartDate : globalState.delistAndReturnTicketFilter.startdate;
          tempData.delistAndReturnTicketFilter.enddate = returnFilterEndDate ? returnFilterEndDate : globalState.delistAndReturnTicketFilter.enddate ;
          tempData.delistAndReturnTicketFilter.startDateRange = null;
          tempData.delistAndReturnTicketFilter.endDateRange = null;
         }else{
          tempData.delistAndReturnTicketFilter.startdate = null;
          tempData.delistAndReturnTicketFilter.enddate = null;
          tempData.delistAndReturnTicketFilter.startDateRange = returnFilterStartDateRange ? returnFilterStartDateRange : globalState.delistAndReturnTicketFilter.startDateRange;
          tempData.delistAndReturnTicketFilter.endDateRange = returnFilterEndDateRange ? returnFilterEndDateRange : globalState.delistAndReturnTicketFilter.endDateRange;
         }
      }else{
        tempData.delistAndReturnTicketFilter.startdate = returnFilterStartDate ? returnFilterStartDate : globalState.delistAndReturnTicketFilter.startdate;
        tempData.delistAndReturnTicketFilter.enddate = returnFilterEndDate ? returnFilterEndDate : globalState.delistAndReturnTicketFilter.enddate ;
        tempData.delistAndReturnTicketFilter.startDateRange = null;
        tempData.delistAndReturnTicketFilter.endDateRange = null;
      }
    }   
  }
  tempData.delistAndReturnTicketFilter.leagueId = returnFilterLeagueId;
  tempData.delistAndReturnTicketFilter.leagueName = returnLeague;
  tempData.delistAndReturnTicketFilter.selectedDateValue = days;
  if(returnFilterStartDateRange && returnFilterEndDateRange){
  tempData.delistAndReturnTicketFilter.isCustomRange = true;
  }
  handleGlobalState(tempData);
  handleCloseFilterDropDown();
}

  return (
    <div className={styles.filterDropdownReturn}>
      <div className={styles.top}>
        <FilterTitle handleCloseFilterDropDown={handleCloseFilterDropDown}/>
        <div className={styles.filterContainerReturn}>
          <div className={styles.container}>
            <div className={styles.filterDetails}>
              <div className={styles.textFieldFullMain}>
                <div className={styles.titlePlaceholder}>
                  <b className={styles.event}>Event</b>
                </div>
                <div className={styles.textField} onClick={handleClickOpenMenu}>
                  <div className={styles.container1}>
                    <div
                      className={
                        returnLeague === "" ? styles.select : styles.leagueSelect
                      }
                    >
                      {returnLeague ? returnLeague : '--Select--'}
                    </div>
                    <img
                      className={styles.sharpOutlineDropdown}
                      alt="dropdownIcon"
                      src={dropdownIcon}
                    />
                  </div>
                </div>
              </div>
              <DateFilter 
                handleClickDays={handleClickDays}
                showDayTick={showDayTick} 
                handleClickCustomRange={handleClicklistCustomRange}
                showCustomRangeValues={showCustomRangeValues} 
                showDatePicker={showDatePickerReturn} 
                startDate={startDateReturn}
                endDate={endDateReturn}
                handleClickOutside={handleClicklistDatePickerOutside} 
                onChange={listDatePickerChange}
              />
            </div>
          </div>
          <ResetApplyButtons handleCancel={handleCancel} handleSubmit= {handleSubmitFilter}/>
        </div>
      </div>
       <LeagueListMenu
        anchorEl ={anchorEl}
        open= {open}
        selectedLeague = {returnLeague}
        handleCloseMenu ={handleCloseMenu}
        handleSelectleague={handleSelectleague}
        leagueslistData = {leagueslistDataInReturn}
      />
    </div>
  );
};

export default DelistAndReturnFilterDropdown;
